import React, { useState } from 'react';
import { Form, ModalBody, ModalFooter, Button, Input, Label, FormFeedback, Row, Col, FormGroup } from 'reactstrap';
import { nameCompany, social, rfcLaboratories, codeCompany, telephone, state, municipality, direction, colonyy, codePostal, emailLaboratory, siteWeb } from '../../constant/index'

export const FormLaboratories = (props) => {

    const {

        toggle, loading, methodAction, button, handleInputChange, validaciones,
        id_state, id_municipality, code, name, business_name, rfc, phone,
        address, colony, cp, email, web_site, states, municipalities, handleChangeState, closeModaLaboratories

    } = props;

    const {
        id_state_valid,
        id_municipality_valid,
        code_valid,
        name_valid,
        business_name_valid,
        rfc_valid,
        address_valid,
        colony_valid,
        cp_valid,
        email_valid,

    } = validaciones;


    return (
        <div className="form-section">
            <Col md="12" className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="section-title">
                    <i className="pi pi-folder-open"></i>
                    Información General
                </h6>

                <small className="section-warning-absolute">
                    <i className="fa fa-exclamation-circle me-1"></i>&nbsp;
                    Complete los campos requeridos
                </small>
            </Col>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{nameCompany}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="name"
                            invalid={name_valid}
                            value={name}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{social}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="business_name"
                            invalid={business_name_valid}
                            value={business_name}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{rfcLaboratories}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="rfc"
                            invalid={rfc_valid}
                            value={rfc}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{codeCompany}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="code"
                            invalid={code_valid}
                            value={code}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{telephone}</Label>
                        <Input
                            type="text"
                            name="phone"
                            value={phone}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>Debes ingresar al menos un número telefonico</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{emailLaboratory}</Label>
                        <Input
                            type="text"
                            name="email"
                            invalid={email_valid}
                            value={email}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>Ingresa un correo válido</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{state}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <select value={id_state} size="sm" name="id_state" className="input-admision"
                            onChange={handleChangeState}>
                            <option value="-1">Selecciona una opción</option>
                            {
                                states.length > 0 && states.map((s, key) => {
                                    return <option key={key} value={s.id_state} >{s.name}</option>
                                })
                            }
                        </select>
                        <Input hidden invalid={id_state_valid} />
                        <FormFeedback>Debes seleccionar una opción</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{municipality}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <select value={id_municipality} size="sm" name="id_municipality" className="input-admision"
                            onChange={handleInputChange}>
                            <option value="-1">Selecciona una opción</option>
                            {
                                municipalities.length > 0 && municipalities.map((m, key) => {
                                    return <option key={key} value={m.id_municipality} >{m.name}</option>
                                })
                            }
                        </select>
                        <Input hidden invalid={id_municipality_valid} />
                        <FormFeedback>Debes seleccionar una opción</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{direction}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="address"
                            invalid={address_valid}
                            value={address}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"
                        />
                        <FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{colonyy}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="colony"
                            invalid={colony_valid}
                            value={colony}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                        <FormFeedback>El campo debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{codePostal}<span style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            name="cp"
                            invalid={cp_valid}
                            value={cp}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"
                        />
                        <FormFeedback>Ingresa un código postal valido</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="label-admision">{siteWeb}</Label>
                        <Input
                            type="text"
                            name="web_site"
                            value={web_site}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"
                        />
                        <FormFeedback>Ingresa un correo válido</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
            </Row>
        </div>

    )
}
